export const ANALYSIS_KEYS = {
  DROPAPIN: "dap",
};
